var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / mail-send"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 4.42407H6C4.897 4.42407 4 5.32107 4 6.42407V11.4241H6V8.42407L12.4 13.2241C12.5732 13.3537 12.7837 13.4238 13 13.4238C13.2163 13.4238 13.4268 13.3537 13.6 13.2241L20 8.42407V17.4241H12V19.4241H20C21.103 19.4241 22 18.5271 22 17.4241V6.42407C22 5.32107 21.103 4.42407 20 4.42407ZM13 11.1741L6.666 6.42407H19.334L13 11.1741Z",
    fill: "#292829"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 12.4241H9V14.4241H2V12.4241ZM4 15.4241H10V17.4241H4V15.4241ZM7 18.4241H11V20.4241H7V18.4241Z",
    fill: "#292829"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailSendIcon);
export default __webpack_public_path__ + "static/media/mail-send-icon.cd7b71737623a8dc3f844f0f08a161c7.svg";
export { ForwardRef as ReactComponent };